$(document).ready(function() {
    // return;
    /**
     * Login pinger.
     */
    (function() {
        var $loginState = {
            success: false
        };

        var $modal = $('[data-role="logout-timeout"]');

        var $interval = null;
        var $running = false;
        var $logout = false;

        $modal.on('click', '[data-action="continue"]', function() {

            if ($logout) {
                window.location.replace("/logout");
                return;
            }

            $running = false;
            $(document).trigger('mousemove');
            $modal.modal('hide');
        });

        $modal.on('click', '[data-action="logout"]', function() {
            window.location.replace("/logout");
        });

        $(document).on('mousemove keydown', function() {
            if ($running) {
                return;
            }
            $running = true;
            $.ajax({
                url: '/auth/ping',
                success: function($response) {

                    $response.current = Math.floor(new Date().getTime() / 1000);
                    $loginState = $response;

                    setTimeout(function() {
                        $running = false;
                    }, 10000);
                }
            });
        }).trigger('mousemove');

        $interval = setInterval(function() {
            if (!$loginState.success) {
                return;
            }

            var $now = Math.floor(new Date().getTime() / 1000);
            var $remaining = ($loginState.current + $loginState.expiry) - $now - 10;
            //console.log('Session remaining: ', $remaining);

            if ($remaining <= 60 && $remaining >= 0) {
                $modal.find('.modal-body').html('<p>You are about to be logged out in <span data-role="seconds">'+($remaining)+'</span> seconds. Click continue to stay logged in.</p>');
                $modal.modal({
                    backdrop: 'static',
                    keyboard: false
                });
                $running = true;
            } else if ($remaining < 0) {
                $modal.find('.modal-body').html('<p>You have been logged out due to inactivity.</p>');
                $modal.find('[data-action="logout"]').hide();
                $logout = true;
                clearInterval($interval);
                setTimeout(function() {
                    window.location.replace("/logout");
                }, 2000);
            } else {
                $modal.modal('hide');
            }

        }, 1000);

    })();

});